/** What the "Set up a fund" example and the /fund command send to the Chief of Staff, which answers with the fund form. */
export const SET_UP_FUND_PROMPT = 'I want to set up a new fund';
